import React from 'react';
import PropTypes from 'prop-types';

export default class AnswerNumber extends React.Component {
  readInput = (event) => {
    const { answerHandler } = this.props;
    answerHandler([event.currentTarget.value]);
  };

  render() {
    const { inputValue } = this.props;

    return (
      <input type="text" name="answer" onInput={this.readInput} onChange={this.readInput} value={inputValue} />
    );
  }
}

AnswerNumber.propTypes = {
  answerHandler: PropTypes.func.isRequired,
  inputValue: PropTypes.arrayOf(PropTypes.string).isRequired,
};
